import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PartnerPlan } from "@/lib/planAccess";

export const useCurrentPlan = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["current-partner-plan"],
    queryFn: async (): Promise<PartnerPlan | null> => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;
      const { data: partner } = await supabase
        .from("partners")
        .select("plano")
        .eq("id", user.id)
        .maybeSingle();
      return (partner?.plano as PartnerPlan) || null;
    },
    staleTime: 60_000,
  });

  return { plan: data ?? null, isLoading };
};
